import { createStytchUIClient } from "@stytch/react/dist/index.ui";
import { StytchProvider } from "@stytch/react";

const client = createStytchUIClient(
  process.env.EXPO_PUBLIC_STYTCH_PUBLIC_TOKEN ?? "",
);

export default function StytchProviderWeb({
  children,
}: {
  children: React.ReactNode;
}) {
  return <StytchProvider stytch={client}>{children}</StytchProvider>;
}
